// constants.js

export const ADD_MODAL_TABS = {
  FIND: 'find',
  CREATE: 'create',
  LIBRARY: 'library',
  TYPE: 'type',
};

export const ADD_MODAL_RELATED_STEPS = Object.freeze({
  TYPE: 'type',
  LINK: 'link',
});

/** Types that skip the link-or-create step and delegate to the parent handler. */
export const ADD_MODAL_IMMEDIATE_RELATED_TYPE_KEYS = new Set([
  'CAMERA',
  'ATTACH',
  'PHOTO',
  'VIDEO',
  'DOCUMENT',
  'FILE',
  'SNAPSHOT',
  'RECORDING',
]);
